"use strict";

var Utility = (function () {
    return {
      displayMessage: function (messageClass, messageSelector, messageText){
        let messageElement = document.querySelector(messageSelector);
        messageElement.innerHTML = messageText;
        
        if (typeof messageClass !== "undefined"){
          messageElement.classList.add(messageClass);
        }
        
        messageElement.classList.remove("hidden");
        messageElement.scrollIntoView({
          behavior: 'smooth'
        });
      },
      getQueryString: function(parameter){
        var urlParams = new URLSearchParams(window.location.search);
        if (typeof parameter === "undefined"){
          return "";
        }
        
        if (urlParams.get(parameter) !== null){
          return urlParams.get(parameter);
        }
        else {
          return "";
        }
      },
      hideLoadingModal: function () {
        $("#loadingModal").hide();
      },
      scrollTo: function (selector, offSetValue) {
        if (typeof offSetValue === 'undefined') {
          offSetValue = 0;
        }

        var element = $(selector);
        var scrollPos = 0;

        if (typeof element !== 'undefined') {
          scrollPos = element.offset().top;
          $("html, body").animate({
            scrollTop: scrollPos + offSetValue
          }, 600);
        }
        else {
          $(window).scrollTop(scrollPos + offSetValue);
        }

        return scrollPos;
      },
      showLoadingModal: function () {
        $("#loadingModal").show();
      }
    };
}());